import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SiteConfig {
  id: string;
  logo_header_url: string;
  logo_footer_url: string;
  email: string;
  phone: string;
  address: string;
  facebook_url: string;
  instagram_url: string;
  tiktok_url: string;
  whatsapp_number: string;
  favicon_url: string;
}

export const useSiteConfig = () => {
  const [siteConfig, setSiteConfig] = useState<SiteConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSiteConfig();
  }, []);

  const loadSiteConfig = async () => {
    try {
      const { data, error } = await supabase
        .from("site_config")
        .select("*")
        .single();
      
      if (error) {
        console.error("Error loading site config:", error);
      } else {
        setSiteConfig(data);
      }
    } catch (error) {
      console.error("Error loading site config:", error);
    } finally {
      setLoading(false);
    }
  };

  return { siteConfig, loading, refetch: loadSiteConfig };
};